import "src/decidim/simple_ui/index"

// Images
require.context("../images", true)
